import { useState, useEffect } from 'react';

/**
 * usePopupModal
 * Shows a popup after `delay` ms on every page load.
 * Closing it only hides it for the current page view —
 * refreshing or revisiting the page will show it again.
 *
 * @param {number} delay - ms to wait before showing the popup (default 5000)
 */
export function usePopupModal(delay = 5000) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const closeModal = () => {
    setIsOpen(false);
  };

  return { isOpen, closeModal };
}